export const UPDATE_CALL_STATUS = 'UPDATE_CALL_STATUS';
export const UPDATE_CALL_DIRECTION = 'UPDATE_CALL_DIRECTION';
export const USER_AVAILABLE = 'USER_AVAILABLE';
export const USER_UNAVAILABLE = 'USER_UNAVAILABLE';
export const LOGGED_IN = 'LOGGED_IN';
export const LOGGED_OUT = 'LOGGED_OUT';
export const UPDATE_WIDGET_DETAILS = 'UPDATE_WIDGET_DETAILS';
export const RESET_WIDGET_DETAILS = 'RESET_WIDGET_DETAILS';
export const REPLACE_WIDGET_DETAILS = 'REPLACE_WIDGET_DETAILS';
export const RESET_REMOTE_CONNECTION = 'RESET_REMOTE_CONNECTION';